const fileTypes = {
    'txt': 'text/plain',
    'json': 'application/json',
    'xml': 'application/xml',
    'pdf': 'application/pdf',
    'doc': 'application/msword',
    'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'xls': 'application/vnd.ms-excel',
    'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'ppt': 'application/vnd.ms-powerpoint',
    'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'jpg': 'image/jpeg',
    'jpeg': 'image/jpeg',
    'png': 'image/png',
    'gif': 'image/gif',
    'bmp': 'image/bmp',
    'svg': 'image/svg+xml',
    'webp': 'image/webp',
    'mp3': 'audio/mpeg',
    'mp4': 'video/mp4',
    'ogg': 'audio/ogg',
    'webm': 'video/webm',
    'wav': 'audio/wav',
    'zip': 'application/zip',
    'tar': 'application/x-tar',
    'gz': 'application/gzip',
    'rar': 'application/x-rar-compressed',
    //programming files
    'c': 'text/x-csrc',
    'java': 'text/x-java',
    'py': 'text/x-python',
    'rb': 'text/x-ruby',
    'php': 'application/x-httpd-php',
    'cs': 'text/x-csharp',
    'swift': 'text/x-swift',
    'go': 'text/x-go',
    'lua': 'text/x-lua',
    'pl': 'application/x-perl',
    'sql': 'application/sql',
    'asm': 'text/x-asm',
    'html': 'text/html',
    'css': 'text/css',
    'scss': 'text/x-scss',
    'sass': 'text/x-sass',
    'ts': 'text/typescript',
    'tsx': 'text/tsx',
    'js': 'text/javascript',
    'jsx': 'text/jsx'
};

export default function blobTypeForIframe(filename) {
    const typ = filename.split('.').pop();
    return fileTypes[typ];
}